module.exports = {
	"_args": [
		[
			"parse5@https://registry.npmjs.org/parse5/-/parse5-2.1.5.tgz",
			"C:\\src\\astexplorer"
		]
	],
	"_from": "parse5@>=2.0.0 <3.0.0",
	"_id": "parse5@2.1.5",
	"_inCache": true,
	"_location": "/parse5",
	"_phantomChildren": {},
	"_requested": {
		"name": "parse5",
		"raw": "parse5@https://registry.npmjs.org/parse5/-/parse5-2.1.5.tgz",
		"rawSpec": "https://registry.npmjs.org/parse5/-/parse5-2.1.5.tgz",
		"scope": null,
		"spec": "https://registry.npmjs.org/parse5/-/parse5-2.1.5.tgz",
		"type": "remote"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/parse5/-/parse5-2.1.5.tgz",
	"_shasum": "7a8677ade25ddac04237905f7be54645572dcf05",
	"_shrinkwrap": null,
	"_spec": "parse5@https://registry.npmjs.org/parse5/-/parse5-2.1.5.tgz",
	"_where": "C:\\src\\astexplorer",
	"author": {
		"email": "ifaaan@gmail.com",
		"name": "Ivan Nikulin",
		"url": "https://github.com/inikulin"
	},
	"bugs": {
		"url": "https://github.com/inikulin/parse5/issues"
	},
	"contributors": [
		{
			"name": "Alan Clarke",
			"url": "https://github.com/alanclarke"
		},
		{
			"name": "Evan You",
			"url": "http://evanyou.me"
		},
		{
			"name": "Saksham Aggarwal",
			"email": "s.agg2021@gmail.com"
		},
		{
			"name": "Sebastian Mayr",
			"email": "sebmaster16@gmail.com",
			"url": "http://blog.smayr.name"
		},
		{
			"name": "Sean Lang",
			"email": "slang800@gmail.com",
			"url": "http://slang.cx"
		}
	],
	"dependencies": {},
	"description": "WHATWG HTML5 specification-compliant, fast and ready for production HTML parsing/serialization toolset for Node.js",
	"devDependencies": {
		"del": "^2.0.2",
		"gulp": "^3.9.0",
		"gulp-benchmark": "^1.1.1",
		"gulp-concat": "^2.6.0",
		"gulp-download": "0.0.1",
		"gulp-eslint": "^1.0.0",
		"gulp-insert": "^0.5.0",
		"gulp-install": "^0.5.0",
		"gulp-jsdoc-to-markdown": "^1.1.1",
		"gulp-mocha": "^2.1.3",
		"gulp-rename": "^1.2.2",
		"promise": "^7.0.4",
		"publish-please": "^1.1.0",
		"through2": "^2.0.0"
	},
	"files": [
		"lib"
	],
	"homepage": "https://github.com/inikulin/parse5",
	"keywords": [
		"WHATWG",
		"fast",
		"html",
		"html parser",
		"html serializer",
		"html5",
		"html5 parser",
		"htmlparser",
		"htmlserializer",
		"parse",
		"parse5",
		"parser",
		"sax",
		"serialize",
		"serializer",
		"simple api",
		"specification",
		"tokenize",
		"tokenizer"
	],
	"license": "MIT",
	"main": "./lib/index.js",
	"name": "parse5",
	"optionalDependencies": {},
	"readme": "<p align=\"center\">\n    <a href=\"https://github.com/inikulin/parse5\">\n        <img src=\"https://raw.github.com/inikulin/parse5/master/docs/logo.png\" alt=\"parse5\" />\n    </a>\n</p>\n\n<p align=\"center\">\n<i>WHATWG HTML5 specification-compliant, fast and ready for production HTML parsing/serialization toolset for Node.js</i>\n</p>\n\n<p align=\"center\">\n  <a href=\"https://travis-ci.org/inikulin/parse5\"><img alt=\"Build Status\" src=\"https://api.travis-ci.org/inikulin/parse5.svg\"></a>\n  <a href=\"https://www.npmjs.com/package/parse5\"><img alt=\"NPM Version\" src=\"https://img.shields.io/npm/v/parse5.svg\"></a>\n  <a href=\"https://npmjs.org/package/parse5\"><img alt=\"Downloads\" src=\"http://img.shields.io/npm/dm/parse5.svg\"></a>\n  <a href=\"https://npmjs.org/package/parse5\"><img alt=\"Downloads total\" src=\"http://img.shields.io/npm/dt/parse5.svg\"></a>\n</p>\n\n<p align=\"center\">\n<b><i>parse5</i></b> provides nearly everything you may need when dealing with HTML. It's the fastest spec-compliant HTML parser\nfor Node to date. It parses HTML the way the latest version of your browser does. It has proven itself reliable in such projects\nas <a href=\"https://github.com/tmpvar/jsdom\">jsdom</a>, <a href=\"https://github.com/angular/angular\">Angular2</a>, <a href=\"https://www.polymer-project.org\">Polymer</a> and many more.\n</p>\n\n----\n\n<p align=\"center\">\n  <a href=\"https://github.com/inikulin/parse5/wiki/Documentation\">Documentation</a>\n</p>\n\n<p align=\"center\">\n  <a href=\"https://github.com/inikulin/parse5/wiki/Documentation#version-history\">Version history</a>\n</p>\n\n<p align=\"center\">\n  <a href=\"http://astexplorer.net/#/1CHlCXc4n4\">Online playground</a>\n</p>\n\n<p align=\"center\">\n  <a href=\"https://github.com/inikulin/parse5/issues\">Issue tracker</a>\n</p>\n",
	"readmeFilename": "README.md",
	"repository": {
		"type": "git",
		"url": "git://github.com/inikulin/parse5.git"
	},
	"scripts": {
		"test": "gulp test"
	},
	"version": "2.1.5"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/parse5/package.json
 ** module id = ./node_modules/parse5/package.json
 ** module chunks = 0
 **/